import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import LoginAlternativeApp from 'views/LoginAlternateApp';
import UserActions from 'store/reducers/User';

const LoginAlternateApp = ( {
  alternateAppData, loginUser,
} ) => {
  useEffect( () => {
    document.title = 'easycall';
  }, [] );

  const logUser = useCallback( () => {
    loginUser( alternateAppData );
  }, [alternateAppData, loginUser] );

  return (
    <LoginAlternativeApp logUser={logUser} alternateAppData={alternateAppData} />
  );
};

const mapStateToProps = ( { user } ) => ( {
  alternateAppData: user.alternateAppData,
} );

const mapDispatchToProps = ( {
  loginUser: UserActions.loginUser,
} );

export default connect( mapStateToProps, mapDispatchToProps )( LoginAlternateApp );
